export type ProductImageHealthRow = {
  url?: string;
  sourceUrl?: string;
  isPrimary?: boolean;
};

export function applyBrokenImageRemediation<T extends ProductImageHealthRow>(
  images: T[],
  isDead: (url: string) => boolean,
): { images: T[]; dropped: number; restored: number } {
  const kept: T[] = [];
  let dropped = 0;
  let restored = 0;

  for (const img of images || []) {
    const url = String(img.url || '').trim();
    if (!url) {
      dropped += 1;
      continue;
    }
    if (!isDead(url)) {
      kept.push(img);
      continue;
    }
    const source = String(img.sourceUrl || '').trim();
    if (source && source !== url && !isDead(source)) {
      kept.push({ ...img, url: source });
      restored += 1;
      continue;
    }
    dropped += 1;
  }

  if (kept.length > 0 && !kept.some((row) => row.isPrimary)) {
    kept[0] = { ...kept[0], isPrimary: true };
  }

  return { images: kept, dropped, restored };
}

export function summarizeImageHealthFix(dropped: number, restored: number): string | null {
  if (dropped === 0 && restored === 0) return null;
  const parts: string[] = [];
  if (restored > 0) {
    parts.push(`restored ${restored} from manufacturer URL${restored === 1 ? '' : 's'}`);
  }
  if (dropped > 0) {
    parts.push(`removed ${dropped} broken image${dropped === 1 ? '' : 's'}`);
  }
  return parts.join('; ');
}
